import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { maskPhoneNumber } from 'utils/validators';
import { isNullOrUndefined } from '@beef/utils';
import { PAGE_PATHS, POPUP_NAMES } from '../../constants';
import {
  changeInviteItems,
  deleteOrCancelChosenCtn,
  newPriceInfoAfterDeleteNumber,
  setActiveStep,
  setPopupStatus,
} from '../../store/actions';
import { pasteCtnToString } from './utils';

const CONTENT_POPUPS_BY_STEP = {
  delete: 'deleteNumber',
  deleteSuccess: 'deleteSuccess',
};

const NOT_SHOW_CROSS_BUTTON_LIST_FOR_STEPS = ['delete'];

export const useCommonModalHOCInit = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const history = useHistory();
  const chosenCtn = (pathname.match(/\d{10}/gi) || []).join();

  const { familyPopupsContent, family, settings, priceInfoAfterDelete } = useSelector((state) => ({
    familyPopupsContent: state?.family?.content?.popups,
    family: state?.family,
    settings: state?.application?.settings,
    priceInfoAfterDelete: state?.family?.familyPopups?.priceAfterDeleteNumberInfo,
  }));

  const { isOpen, step } = family?.familyPopups;
  const { popupRequestStatus } = family;
  const { ctn } = settings;

  // цена и период полаты после удаления номера из семьи
  const { price, unit } = priceInfoAfterDelete || {};

  useEffect(() => {
    if (step === POPUP_NAMES.delete) {
      dispatch(newPriceInfoAfterDeleteNumber(ctn, chosenCtn));
    }
  }, []);

  let size;

  /** Удаление номера или отмена приглашения в Семью */
  const handleDeleteOrCancelInvitation = useCallback(() => {
    dispatch(deleteOrCancelChosenCtn(chosenCtn));
  }, [chosenCtn]);

  /** Закрытие попапа */
  const handleCloseModal = useCallback(() => {
    dispatch(setPopupStatus(false));
    dispatch(setActiveStep(''));
  }, []);

  /** Успешное удаление номера или отмена приглашения */
  const handleDeleteOrCancelSuccess = useCallback(() => {
    dispatch(changeInviteItems(chosenCtn));
    history.push(PAGE_PATHS.information);
    handleCloseModal();
  }, [chosenCtn]);

  // управление для каждой кнопки в зависимости от шага
  const resolveActions = {
    delete: handleDeleteOrCancelInvitation,
    deleteSuccess: handleDeleteOrCancelSuccess,
  };

  const resolveAdditionalActions = {
    delete: handleCloseModal,
  };

  // не показывать в модалке крестик на определенном шаге
  const isShowCrossButton = !NOT_SHOW_CROSS_BUTTON_LIST_FOR_STEPS.includes(step);

  let currentPopupData = familyPopupsContent[CONTENT_POPUPS_BY_STEP[step]] || {};

  // если нужно поменять данные из QP для правильно отображения
  switch (step) {
    case 'delete':
      size = 's';

      currentPopupData = { ...currentPopupData,
        title: pasteCtnToString(currentPopupData.title, '{{CELLNUMBER}}', maskPhoneNumber(chosenCtn)),
        description: isNullOrUndefined(price) ? '' : pasteCtnToString(
          currentPopupData.description,
          '{{PRICE_NUMBER}}',
          `${price} ${unit}`,
        ) };
      break;
    case 'deleteSuccess':
      size = 's';

      currentPopupData = { ...currentPopupData,
        title: pasteCtnToString(currentPopupData.title, '{{CELLNUMBER}}', maskPhoneNumber(chosenCtn)) };
      break;
    default:
      break;
  }

  return {
    currentPopupData,
    isShowCrossButton,
    resolveAdditionalActions,
    resolveActions,
    size,
    isOpen,
    popupRequestStatus,
    step,
  };
};
